export default __webpack_public_path__ + "assets/overdue-doc.2c3e.svg";